import React, { useState, useCallback } from "react";
import axios from "axios";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    formType: "contact",
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // API URL from environment variables
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

  // Handle input changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  // Validate form inputs
  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
      newErrors.name = "Name must contain only letters and spaces.";
      isValid = false;
    }

    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
      isValid = false;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be exactly 10 digits.";
      isValid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message cannot be empty.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!validateForm()) return;

      setLoading(true);
      try {
        await axios.post(`${apiUrl}/submit`, formData);
        alert("Form submitted successfully!");

        // Reset form fields after successful submission
        setFormData({ formType: "contact", name: "", email: "", phone: "", message: "" });
        setErrors({});
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Error submitting form.");
      } finally {
        setLoading(false);
      }
    },
    [formData, apiUrl]
  );

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {["name", "email", "phone"].map((field, index) => (
        <div key={index}>
          <label htmlFor={field} className="block text-sm font-medium text-gray-700">
            {field.charAt(0).toUpperCase() + field.slice(1)}
          </label>
          <input
            type={field === "email" ? "email" : field === "phone" ? "tel" : "text"}
            id={field}
            className={`mt-1 block w-full px-4 py-2 border ${
              errors[field] ? "border-red-500" : "border-gray-300"
            } rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500`}
            placeholder={`Your ${field.charAt(0).toUpperCase() + field.slice(1)}`}
            required
            value={formData[field]}
            onChange={handleChange}
            disabled={loading}
          />
          {errors[field] && <p className="text-red-500 text-sm mt-1">{errors[field]}</p>}
        </div>
      ))}

      <div>
        <label htmlFor="message" className="block text-sm font-medium text-gray-700">
          Message
        </label>
        <textarea
          id="message"
          rows="4"
          className={`mt-1 block w-full px-4 py-2 border ${
            errors.message ? "border-red-500" : "border-gray-300"
          } rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500`}
          placeholder="Your Message"
          required
          value={formData.message}
          onChange={handleChange}
          disabled={loading}
        ></textarea>
        {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
      </div>

      <button
        type="submit"
        className="w-full bg-primary text-white py-2 px-4 rounded-lg hover:bg-secondary transition"
        disabled={loading}
      >
        {loading ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
};

export default ContactForm;
